module.exports = __webpack_public_path__ + "img/88e76d87331160db2d78a0c56859c83c.png";